export const wizardStepsInit = (onAccessoUtenteChanging) => {
  (function ($) {
    var form = $(".steps-validation").show();

    $(".steps-validation").steps({
      headerTag: "h6",
      bodyTag: "fieldset",
      transitionEffect: "fade",
      titleTemplate: '<span class="step">#index#</span> #title#',

      onStepChanging: function (event, currentIndex, newIndex) {
        if (currentIndex > newIndex) return true;

        if (currentIndex < newIndex) {
          form.find(".body:eq(" + newIndex + ") label.error").remove();
          form.find(".body:eq(" + newIndex + ") .error").removeClass("error");
        }
        form.find(".body:eq(" + newIndex + ") label.error").remove();
        form.find(".body:eq(" + newIndex + ") .error").removeClass("error");

        if (typeof onAccessoUtenteChanging === 'function') {
          const canProceed = onAccessoUtenteChanging(currentIndex, newIndex);
          if (canProceed === false) return false;
        }

        form.validate().settings.ignore = ":disabled,:hidden";
        return form.valid();
      },
      onFinishing: function (event, currentIndex) {
        form.validate().settings.ignore = ":disabled";
        return form.valid();
      },
      onFinished: function (event, currentIndex) { }
    });

    $('.step-icon').each(function () {
      var $this = $(this);
      if ($this.siblings('span.step').length > 0) {
        $this.siblings('span.step').empty();
        $(this).appendTo($(this).siblings('span.step'));
      }
    });

  })(window.jQuery);
}

export const wizardStepsDestroy = () => {
  (function ($) {
    try {
      var $wizard = $(".steps-validation");
      if ($wizard.length) {
        $wizard.steps("destroy");
      }
    } catch (err) {
      console.warn("wizardStepsDestroy error:", err);
    }
  })(window.jQuery);
}